import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Dialog, Heading } from '@innovationnorway/cl-react';

interface ArchiveStepProps {
  dialogOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  onArchiveAndSend: () => Promise<void>;
  onSendWithoutArchive: () => void;
}

const ArchiveStep = ({
  dialogOpen,
  onClose,
  isLoading,
  onArchiveAndSend,
  onSendWithoutArchive,
}: ArchiveStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const [archiveError, setArchiveError] = useState(false);

  return (
    <Dialog open={dialogOpen} onClose={onClose} aria-label={tOneWayIn('refer.dialog.ariaLabel')}>
      <div className="display--flex flex-direction--column gap--ds-10">
        <Heading level={2} className="font-size--ds-6 font-weight--500">
          {tOneWayIn('refer.dialog.archivePrompt.title')}
        </Heading>
        {archiveError && <Alert data-color="danger">{tOneWayIn('refer.dialog.archivePrompt.error')}</Alert>}
        <div className="display--flex gap--ds-5">
          <Button
            loading={isLoading}
            disabled={isLoading}
            onClick={async () => {
              setArchiveError(false);
              try {
                await onArchiveAndSend();
              } catch {
                setArchiveError(true);
              }
            }}
          >
            {tCommon('yes')}
          </Button>
          <Button variant="secondary" disabled={isLoading} onClick={onSendWithoutArchive}>
            {tCommon('no')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ArchiveStep;
